module.exports = __webpack_public_path__ + "img/image.909128e8.svg";